import React, { useState, useEffect, useMemo, useCallback } from 'react';
import './Productionnomenclature.css';

/* ===================================================
   ★ CONFIGURATION — modifie uniquement ces valeurs
   =================================================== */
const API =
  window.location.hostname === 'localhost'
    ? 'http://localhost:5000'
    : 'https://demo.myssa.net';

// ★ true = données d'exemple (pour tester l'écran) | false = données PostgreSQL via l'API
const USE_DEMO_DATA = true;

// ★ Routes API (à créer côté Express)
const ROUTES = {
  items: '/api/nomenclature/items',             // base article : item, description, unite, stock, delai_appro
  nomenclatures: '/api/nomenclature/liste',     // entêtes + lignes
  commandes: '/api/nomenclature/commandes',     // commandes clients PF non soldées
  save: '/api/nomenclature/save',               // POST création / modification
};

// ★ Planning
const HORIZONS = [4, 8, 12, 16, 26, 52];          // choix de l'horizon (semaines)
const HORIZON_DEFAUT = 12;
const ECHELLE_DEFAUT = 'week';                    // 'day' | 'week' | 'month'
const SEMAINES_PASSEES = 1;                       // semaines affichées avant aujourd'hui
const PX_PAR_JOUR = { day: 30, week: 14, month: 5 }; // largeur mini du Gantt par jour
const LARGEUR_LIBELLE = 280;                      // ★ même valeur que --pn-label-w dans le CSS

// ★ Sous-onglets
const SOUS_ONGLETS = [
  { key: 'nomenclature', label: 'Nomenclature' },
  { key: 'casemploi', label: "Cas d'emploi" },
  { key: 'plan', label: 'Plan de production' },
  { key: 'planning', label: 'Planning production' },
  { key: 'creer', label: 'Créer / modifier' },
];

const ECHELLES = [
  { key: 'day', label: 'Jours' },
  { key: 'week', label: 'Semaines' },
  { key: 'month', label: 'Mois' },
];

const MOIS = ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];
const LETTRES_JOURS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

/* ===================================================
   DONNÉES D'EXEMPLE (USE_DEMO_DATA = true) — thème vélo
   4 kits montés à partir des articles de « I donnée client base article ».
   ★ Délai d'un kit = délai appro du composant le plus long + 2 jours de création du kit
   ★ Dates des commandes calculées à partir d'aujourd'hui (la démo reste à jour)
   =================================================== */
const CREATION_KIT_JOURS = 2;   // ★ temps de création / assemblage d'un kit (jours)

// Date ISO (AAAA-MM-JJ) à N jours d'aujourd'hui
const dansJours = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Composants (base article vélo) : délai appro en jours ouvrés
const DEMO_COMPOSANTS = [
  { item: 'SACOCHE-SELLE-1L', description: 'Sacoche de selle 1L – Ortlieb Micro Two noir', unite: 'U', stock: 12, delai_appro: 7 },
  { item: 'CHAMBRE-700-PRESTA', description: 'Chambre à air 700x25-32C valve Presta 48mm', unite: 'U', stock: 120, delai_appro: 3 },
  { item: 'MONTAGE-PNEU-SET', description: 'Démonte-pneus plastique (jeu de 3) – Park Tool TL-4.2', unite: 'U', stock: 60, delai_appro: 3 },
  { item: 'KIT-CREVAISON', description: 'Kit réparation crevaison multi-usage – Park Tool VP-1', unite: 'U', stock: 48, delai_appro: 3 },
  { item: 'POMPE-CO2-16G', description: 'Gonfleur CO2 + 3 cartouches 16g – Lezyne Control Drive', unite: 'U', stock: 40, delai_appro: 5 },
  { item: 'MULTI-OUTIL-16', description: 'Multi-outil 16 fonctions – Topeak Alien II', unite: 'U', stock: 38, delai_appro: 5 },
  { item: 'MAILLON-RAPIDE-11V', description: 'Maillon rapide 11v – KMC CL555 (sachet de 5)', unite: 'U', stock: 55, delai_appro: 3 },
  { item: 'GOURDE-750-ELITE', description: 'Gourde vélo 750ml isotherme – Elite Fly bleu translucide', unite: 'U', stock: 85, delai_appro: 3 },
  { item: 'PORTE-BIDON-ALU', description: 'Porte-bidon aluminium – Elite Custom Race noir', unite: 'U', stock: 120, delai_appro: 3 },
  { item: 'VISSERIE-M5-INX20', description: 'Visserie M5x12mm tête creuse inox (lot de 20)', unite: 'U', stock: 140, delai_appro: 3 },
  { item: 'PASTILLES-ELECTROLYTES', description: 'Pastilles électrolytes effervescentes (tube de 20) – High5 Zero citron', unite: 'U', stock: 40, delai_appro: 5 },
  { item: 'DEGR-TRANSMISSION', description: 'Dégraissant chaîne & transmission 500ml – Muc-Off Bio', unite: 'U', stock: 40, delai_appro: 3 },
  { item: 'LUBRIFIANT-SEC', description: 'Lubrifiant chaîne conditions sèches 120ml – Rock N Roll Gold', unite: 'U', stock: 55, delai_appro: 3 },
  { item: 'LUBRIFIANT-HUMIDE', description: 'Lubrifiant chaîne conditions humides 100ml – Finish Line Wet', unite: 'U', stock: 60, delai_appro: 3 },
  { item: 'BROSSE-TRANSM', description: 'Brosse nettoyage transmission – Park Tool GSC-3', unite: 'U', stock: 30, delai_appro: 5 },
  { item: 'CHIFFONS-MICRO-10X', description: 'Chiffons microfibre 40x40cm (lot de 10) – Park Tool', unite: 'U', stock: 25, delai_appro: 3 },
  { item: 'GRAISSE-MONTAGE', description: 'Graisse montage & assemblage 150g – Finish Line Premium', unite: 'U', stock: 30, delai_appro: 5 },
  { item: 'FOND-JANTE-TL-29', description: 'Fond de jante tubeless 29" 35mm (paire) – Stan\'s', unite: 'U', stock: 30, delai_appro: 5 },
  { item: 'VALVE-TL-PRESTA', description: 'Valves tubeless aluminium Presta 44mm (paire)', unite: 'U', stock: 45, delai_appro: 3 },
  { item: 'LIQUIDE-TL-500', description: 'Liquide préventif tubeless 500ml – Stan\'s NoTubes', unite: 'U', stock: 9, delai_appro: 5 },
];

// Kits (produits finis) : composition
const DEMO_KITS = [
  { ref_pf: 'KIT-REPARATION-ROUTE', description: 'Kit réparation crevaison route – sacoche de selle équipée', version: 'v2', date_maj: dansJours(-18),
    lignes: [{ item: 'SACOCHE-SELLE-1L', quantite: 1 }, { item: 'CHAMBRE-700-PRESTA', quantite: 2 }, { item: 'MONTAGE-PNEU-SET', quantite: 1 }, { item: 'KIT-CREVAISON', quantite: 1 }, { item: 'POMPE-CO2-16G', quantite: 1 }, { item: 'MULTI-OUTIL-16', quantite: 1 }, { item: 'MAILLON-RAPIDE-11V', quantite: 1 }] },
  { ref_pf: 'KIT-HYDRATATION-SORTIE', description: 'Kit hydratation sortie longue – 2 gourdes + porte-bidons + électrolytes', version: 'v1', date_maj: dansJours(-40),
    lignes: [{ item: 'GOURDE-750-ELITE', quantite: 2 }, { item: 'PORTE-BIDON-ALU', quantite: 2 }, { item: 'VISSERIE-M5-INX20', quantite: 1 }, { item: 'PASTILLES-ELECTROLYTES', quantite: 2 }] },
  { ref_pf: 'KIT-ENTRETIEN-TRANSM', description: 'Kit entretien transmission – dégraissant, lubrifiants, brosse, chiffons', version: 'v1', date_maj: dansJours(-65),
    lignes: [{ item: 'DEGR-TRANSMISSION', quantite: 1 }, { item: 'LUBRIFIANT-SEC', quantite: 1 }, { item: 'LUBRIFIANT-HUMIDE', quantite: 1 }, { item: 'BROSSE-TRANSM', quantite: 1 }, { item: 'CHIFFONS-MICRO-10X', quantite: 1 }, { item: 'GRAISSE-MONTAGE', quantite: 1 }] },
  { ref_pf: 'KIT-TUBELESS-VTT-29', description: 'Kit conversion tubeless VTT 29" – fond de jante, valves, liquide, démonte-pneus', version: 'v1', date_maj: dansJours(-9),
    lignes: [{ item: 'FOND-JANTE-TL-29', quantite: 1 }, { item: 'VALVE-TL-PRESTA', quantite: 1 }, { item: 'LIQUIDE-TL-500', quantite: 1 }, { item: 'MONTAGE-PNEU-SET', quantite: 1 }] },
];

// Délai appro du kit = composant le plus long + création du kit
const delaiKit = (k) => Math.max(...k.lignes.map((l) => DEMO_COMPOSANTS.find((c) => c.item === l.item)?.delai_appro || 0)) + CREATION_KIT_JOURS;

const DEMO = {
  items: [
    ...DEMO_KITS.map((k) => ({ item: k.ref_pf, description: k.description, unite: 'U', stock: 0, delai_appro: delaiKit(k) })),
    ...DEMO_COMPOSANTS,
  ],
  nomenclatures: DEMO_KITS.map((k) => ({
    ref_pf: k.ref_pf, version: k.version, date_maj: k.date_maj,
    temps_production: CREATION_KIT_JOURS,   // 2 jours de création du kit
    lignes: k.lignes,
  })),
  commandes: [
    { commande: 'CC-2609', client: 'Atelier du Rayon', ref_pf: 'KIT-ENTRETIEN-TRANSM', quantite: 8, date_livraison: dansJours(2) },
    { commande: 'CC-2611', client: 'Cycles Martin', ref_pf: 'KIT-REPARATION-ROUTE', quantite: 20, date_livraison: dansJours(7) },
    { commande: 'CC-2614', client: 'Atelier du Rayon', ref_pf: 'KIT-ENTRETIEN-TRANSM', quantite: 15, date_livraison: dansJours(16) },
    { commande: 'CC-2618', client: 'Vélo Station Lyon', ref_pf: 'KIT-HYDRATATION-SORTIE', quantite: 30, date_livraison: dansJours(24) },
    { commande: 'CC-2620', client: 'Bike Club Annecy', ref_pf: 'KIT-TUBELESS-VTT-29', quantite: 12, date_livraison: dansJours(31) },
    { commande: 'CC-2623', client: 'Cycles Martin', ref_pf: 'KIT-REPARATION-ROUTE', quantite: 15, date_livraison: dansJours(45) },
    { commande: 'CC-2627', client: 'Vélo Station Lyon', ref_pf: 'KIT-HYDRATATION-SORTIE', quantite: 25, date_livraison: dansJours(52) },
  ],
};

/* ===================================================
   UTILITAIRES DATES / FORMAT
   =================================================== */
const DAY = 86400000;
const toDate = (s) => {
  if (!s) return null;
  const [y, m, d] = String(s).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
};
const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
const diffDays = (a, b) => Math.round((a - b) / DAY);
const pad = (n) => String(n).padStart(2, '0');
const formatDate = (d) => (d ? `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}` : '');
const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const fr = (n) => Number(n || 0).toLocaleString('fr-FR');
const startOfWeek = (d) => addDays(d, -((d.getDay() + 6) % 7));
const isoWeek = (d) => {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = (t.getUTCDay() + 6) % 7;
  t.setUTCDate(t.getUTCDate() - day + 3);
  const j4 = new Date(Date.UTC(t.getUTCFullYear(), 0, 4));
  return 1 + Math.round(((t - j4) / DAY - 3 + ((j4.getUTCDay() + 6) % 7)) / 7);
};
const lsGet = (k, def) => {
  try { const v = localStorage.getItem(k); return v === null ? def : JSON.parse(v); } catch { return def; }
};
const lsSet = (k, v) => {
  try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* ignore */ }
};

const today = (() => { const n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); })();

/* ===================================================
   COMPOSANT
   =================================================== */
const Productionnomenclature = () => {
  const [onglet, setOnglet] = useState('nomenclature');
  const [data, setData] = useState({ items: [], nomenclatures: [], commandes: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [product, setProduct] = useState('');
  const [item, setItem] = useState('');
  const [target, setTarget] = useState(toISO(addDays(today, 30)));

  const [echelle, setEchelle] = useState(() => lsGet('pn_echelle', ECHELLE_DEFAUT));
  const [horizon, setHorizon] = useState(() => lsGet('pn_horizon', HORIZON_DEFAUT));

  const [ofSel, setOfSel] = useState(null);   // OF sélectionné dans le planning (n° de commande)
  const [planFiltre, setPlanFiltre] = useState('tous'); // filtre statut du Plan de production

  const [draft, setDraft] = useState({ ref_pf: '', version: 'v1', temps_production: 1, lignes: [] });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    document.title = 'MYSSA – Production & Nomenclature';
  }, []);

  useEffect(() => { lsSet('pn_echelle', echelle); }, [echelle]);
  useEffect(() => { lsSet('pn_horizon', horizon); }, [horizon]);

  /* ---------- Chargement ---------- */
  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (USE_DEMO_DATA) {
        setData(DEMO);
      } else {
        const [items, nomenclatures, commandes] = await Promise.all(
          [ROUTES.items, ROUTES.nomenclatures, ROUTES.commandes].map((r) =>
            fetch(`${API}${r}`).then((res) => {
              if (!res.ok) throw new Error(`Erreur API ${r}`);
              return res.json();
            })
          )
        );
        setData({ items, nomenclatures, commandes });
      }
    } catch (e) {
      console.error('Erreur chargement nomenclatures :', e);
      setError('Impossible de charger les données.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadData(); }, [loadData]);

  /* ---------- Index ---------- */
  const itemsMap = useMemo(() => {
    const m = {};
    data.items.forEach((i) => { m[i.item] = i; });
    return m;
  }, [data.items]);

  const bomMap = useMemo(() => {
    const m = {};
    data.nomenclatures.forEach((n) => { m[n.ref_pf] = n; });
    return m;
  }, [data.nomenclatures]);

  const descOf = (ref) => itemsMap[ref]?.description || '—';

  // Sélections par défaut une fois les données chargées
  useEffect(() => {
    if (!product && data.nomenclatures.length) setProduct(data.nomenclatures[0].ref_pf);
  }, [data.nomenclatures, product]);

  // Items utilisés dans au moins une nomenclature
  const usedItems = useMemo(() => {
    const s = new Set();
    data.nomenclatures.forEach((n) => n.lignes.forEach((l) => s.add(l.item)));
    return Array.from(s).sort();
  }, [data.nomenclatures]);

  useEffect(() => {
    if (!item && usedItems.length) setItem(usedItems[0]);
  }, [usedItems, item]);

  /* ---------- Stock réservé par les commandes clients ---------- */
  const reserved = useMemo(() => {
    const r = {};
    data.commandes.forEach((c) => {
      const b = bomMap[c.ref_pf];
      if (!b) return;
      b.lignes.forEach((l) => {
        r[l.item] = (r[l.item] || 0) + Number(l.quantite) * Number(c.quantite);
      });
    });
    return r;
  }, [data.commandes, bomMap]);

  /* ---------- Planning : affectation du stock par date de livraison ---------- */
  const plan = useMemo(() => {
    const rem = {};
    data.items.forEach((i) => { rem[i.item] = Number(i.stock) || 0; });
    return data.commandes
      .filter((c) => bomMap[c.ref_pf])
      .slice()
      .sort((a, b) => toDate(a.date_livraison) - toDate(b.date_livraison))
      .map((c) => {
        const b = bomMap[c.ref_pf];
        const manquants = [];
        const lignesDetail = [];
        let delai = 0;
        b.lignes.forEach((l) => {
          const besoin = Number(l.quantite) * Number(c.quantite);
          const dispoAvant = rem[l.item] || 0;
          if (dispoAvant >= besoin) {
            rem[l.item] -= besoin;
            lignesDetail.push({ item: l.item, quantite: Number(l.quantite), besoin, dispoAvant, manque: 0, couvert: true });
          } else {
            rem[l.item] = 0;
            manquants.push(l.item);
            delai = Math.max(delai, Number(itemsMap[l.item]?.delai_appro) || 0);
            lignesDetail.push({ item: l.item, quantite: Number(l.quantite), besoin, dispoAvant, manque: besoin - dispoAvant, couvert: false });
          }
        });
        const livraison = toDate(c.date_livraison);
        const debutProd = addDays(livraison, -Number(b.temps_production || 0));
        const debutAppro = addDays(debutProd, -delai);
        const retard = delai > 0 && debutAppro < today;
        let statut = 'Stock OK';
        if (retard) statut = 'Retard appro';
        else if (debutProd <= today) statut = 'En production';
        else if (delai > 0) statut = 'Commande à passer';
        return { c, b, manquants, lignesDetail, delai, livraison, debutProd, debutAppro, retard, statut };
      });
  }, [data.commandes, data.items, bomMap, itemsMap]);

  /* ===================================================
     ACTIONS
     =================================================== */
  const openCasEmploi = (ref) => { setItem(ref); setOnglet('casemploi'); };
  const openNomenclature = (ref, dateLiv) => {
    setProduct(ref);
    if (dateLiv) setTarget(String(dateLiv).slice(0, 10));
    setOnglet('nomenclature');
  };

  const nouvelleNomenclature = () => {
    setDraft({ ref_pf: '', version: 'v1', temps_production: 1, lignes: [{ item: '', quantite: 1 }] });
    setOnglet('creer');
  };

  const modifierNomenclature = () => {
    const b = bomMap[product];
    if (!b) return;
    const num = parseInt(String(b.version).replace(/\D/g, ''), 10) || 0;
    setDraft({
      ref_pf: b.ref_pf,
      version: `v${num + 1}`,
      temps_production: b.temps_production,
      lignes: b.lignes.map((l) => ({ ...l })),
    });
    setOnglet('creer');
  };

  const dupliquerNomenclature = () => {
    const b = bomMap[product];
    if (!b) return;
    setDraft({ ref_pf: '', version: 'v1', temps_production: b.temps_production, lignes: b.lignes.map((l) => ({ ...l })) });
    setOnglet('creer');
  };

  const copierDepuis = (ref) => {
    const b = bomMap[ref];
    if (!b) return;
    setDraft((d) => ({ ...d, temps_production: b.temps_production, lignes: b.lignes.map((l) => ({ ...l })) }));
  };

  const majLigne = (i, champ, val) => {
    setDraft((d) => {
      const lignes = d.lignes.slice();
      lignes[i] = { ...lignes[i], [champ]: val };
      return { ...d, lignes };
    });
  };
  const ajouterLigne = () => setDraft((d) => ({ ...d, lignes: [...d.lignes, { item: '', quantite: 1 }] }));
  const supprimerLigne = (i) => setDraft((d) => ({ ...d, lignes: d.lignes.filter((_, j) => j !== i) }));

  const enregistrer = async () => {
    const lignes = draft.lignes
      .filter((l) => l.item && Number(l.quantite) > 0)
      .map((l) => ({ item: l.item, quantite: Number(l.quantite) }));
    if (!draft.ref_pf) { alert('Choisis un produit fini.'); return; }
    if (!lignes.length) { alert('Ajoute au moins une ligne avec une quantité.'); return; }

    const nomenclature = {
      ref_pf: draft.ref_pf,
      version: draft.version || 'v1',
      temps_production: Number(draft.temps_production) || 0,
      date_maj: toISO(today),
      lignes,
    };

    setSaving(true);
    try {
      if (USE_DEMO_DATA) {
        setData((d) => ({
          ...d,
          nomenclatures: [...d.nomenclatures.filter((n) => n.ref_pf !== nomenclature.ref_pf), nomenclature],
        }));
      } else {
        const res = await fetch(`${API}${ROUTES.save}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(nomenclature),
        });
        if (!res.ok) throw new Error('Erreur enregistrement');
        await loadData();
      }
      setProduct(nomenclature.ref_pf);
      setOnglet('nomenclature');
    } catch (e) {
      console.error(e);
      alert("Erreur lors de l'enregistrement de la nomenclature.");
    } finally {
      setSaving(false);
    }
  };

  /* ===================================================
     VUE 1 — NOMENCLATURE
     =================================================== */
  const renderNomenclature = () => {
    const b = bomMap[product];
    if (!b) return <div className="pn-card pn-empty">Aucune nomenclature. Crée la première avec « + Nouvelle nomenclature ».</div>;

    const tgt = toDate(target) || today;
    const lancement = addDays(tgt, -Number(b.temps_production || 0));

    let capacite = Infinity;
    let limitant = '';
    b.lignes.forEach((l) => {
      const net = Math.max(0, (Number(itemsMap[l.item]?.stock) || 0) - (reserved[l.item] || 0));
      const c = Math.floor(net / Number(l.quantite));
      if (c < capacite) { capacite = c; limitant = l.item; }
    });
    if (capacite === Infinity) capacite = 0;

    return (
      <>
        <div className="pn-card pn-filters">
          <div className="pn-field pn-field-grow">
            <label className="pn-label" htmlFor="pn-pf">Produit fini</label>
            <select id="pn-pf" className="pn-select" value={product} onChange={(e) => setProduct(e.target.value)}>
              {data.nomenclatures.map((n) => (
                <option key={n.ref_pf} value={n.ref_pf}>{n.ref_pf} — {descOf(n.ref_pf)}</option>
              ))}
            </select>
          </div>
          <div className="pn-field">
            <label className="pn-label" htmlFor="pn-target">Date de livraison PF souhaitée</label>
            <input id="pn-target" type="date" className="pn-input pn-mono" value={target} onChange={(e) => e.target.value && setTarget(e.target.value)} />
          </div>
          <div className="pn-actions">
            <button type="button" className="pn-btn" onClick={modifierNomenclature}>Modifier</button>
            <button type="button" className="pn-btn" onClick={dupliquerNomenclature}>Dupliquer</button>
          </div>
        </div>

        <div className="pn-kpis">
          <div className="pn-kpi">
            <div className="pn-kpi-label">Composants · version</div>
            <div className="pn-kpi-value">{b.lignes.length} · {b.version}</div>
            <div className="pn-kpi-sub">modifiée le {formatDate(toDate(b.date_maj))}</div>
          </div>
          <div className="pn-kpi">
            <div className="pn-kpi-label">Temps de production</div>
            <div className="pn-kpi-value">{b.temps_production} j</div>
            <div className="pn-kpi-sub">lancement au plus tard le {formatDate(lancement)}</div>
          </div>
          <div className="pn-kpi pn-kpi-dark">
            <div className="pn-kpi-label">Capacité sur stock dispo</div>
            <div className="pn-kpi-value">{fr(capacite)} u.</div>
            <div className="pn-kpi-sub">après déduction des commandes clients</div>
          </div>
          <div className="pn-kpi pn-kpi-warn">
            <div className="pn-kpi-label">Composant limitant</div>
            <div className="pn-kpi-value pn-kpi-value-sm">{limitant || '—'}</div>
            <div className="pn-kpi-sub">{limitant ? descOf(limitant) : ''}</div>
          </div>
        </div>

        <div className="pn-card pn-table-card">
          <div className="pn-table-head">
            <div className="pn-table-title">{b.ref_pf} — {descOf(b.ref_pf)}</div>
            <div className="pn-table-hint">Livraison le {formatDate(tgt)} → dates de commande calculées à rebours</div>
          </div>
          <div className="pn-table-wrap">
            <table className="pn-table pn-table-bom">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Description</th>
                  <th className="num">Qté</th>
                  <th>Unité</th>
                  <th className="num">Stock en main</th>
                  <th className="num">Réservé cdes clients</th>
                  <th className="num pn-col-net">Stock dispo net</th>
                  <th className="num">Délai appro</th>
                  <th>Commander avant le</th>
                  <th className="num">PF réalisables</th>
                </tr>
              </thead>
              <tbody>
                {b.lignes.map((l) => {
                  const it = itemsMap[l.item] || {};
                  const stock = Number(it.stock) || 0;
                  const res = reserved[l.item] || 0;
                  const net = stock - res;
                  const delai = Number(it.delai_appro) || 0;
                  const commanderAvant = addDays(lancement, -delai);
                  const enRetard = commanderAvant < today;
                  const couverture = Math.floor(Math.max(0, net) / Number(l.quantite));
                  return (
                    <tr key={l.item}>
                      <td className="pn-mono">
                        <button type="button" className="pn-link" onClick={() => openCasEmploi(l.item)}>{l.item}</button>
                      </td>
                      <td>{it.description || '—'}</td>
                      <td className="num pn-mono">{fr(l.quantite)}</td>
                      <td className="pn-muted">{it.unite || ''}</td>
                      <td className="num pn-mono">{fr(stock)}</td>
                      <td className="num pn-mono pn-muted">− {fr(res)}</td>
                      <td className="num pn-mono pn-col-net">
                        {net < 0 ? <span className="pn-badge pn-badge-warn">{fr(net)}</span> : <strong>{fr(net)}</strong>}
                      </td>
                      <td className="num pn-mono">{delai} j</td>
                      <td className="pn-mono">
                        {enRetard
                          ? <span className="pn-badge pn-badge-warn">{formatDate(commanderAvant)} · retard</span>
                          : formatDate(commanderAvant)}
                      </td>
                      <td className="num pn-mono">
                        {l.item === limitant
                          ? <span className="pn-badge pn-badge-warn">{fr(couverture)} · limitant</span>
                          : fr(couverture)}
                      </td>
                    </tr>
                  );
                })}
                <tr className="pn-row-prod">
                  <td className="pn-mono"><strong>PRODUCTION</strong></td>
                  <td>Production / assemblage du PF</td>
                  <td className="num pn-mono"><strong>{b.temps_production}</strong></td>
                  <td>jours</td>
                  <td className="num pn-muted">—</td>
                  <td className="num pn-muted">—</td>
                  <td className="num pn-muted">—</td>
                  <td className="num pn-muted">—</td>
                  <td className="pn-mono"><strong>Lancer le {formatDate(lancement)}</strong></td>
                  <td className="num pn-muted">—</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="pn-footnote">
            Stock dispo net = stock en main − besoins des commandes clients enregistrées. Commander avant le = livraison PF − temps de production − délai appro du composant.
          </div>
        </div>
      </>
    );
  };

  /* ===================================================
     VUE 2 — CAS D'EMPLOI
     =================================================== */
  const renderCasEmploi = () => {
    const it = itemsMap[item] || {};
    const usages = [];
    data.nomenclatures.forEach((n) => {
      n.lignes.forEach((l) => { if (l.item === item) usages.push({ n, quantite: Number(l.quantite) }); });
    });
    const total = usages.reduce((a, u) => a + u.quantite, 0) || 1;
    const stock = Number(it.stock) || 0;

    return (
      <>
        <div className="pn-card pn-filters">
          <div className="pn-field pn-field-grow">
            <label className="pn-label" htmlFor="pn-item">Item / composant</label>
            <select id="pn-item" className="pn-select" value={item} onChange={(e) => setItem(e.target.value)}>
              {usedItems.map((ref) => (
                <option key={ref} value={ref}>{ref} — {descOf(ref)}</option>
              ))}
            </select>
          </div>
          <div className="pn-mini-stats">
            <div><div className="pn-label">En main</div><div className="pn-mini-value">{fr(stock)} {it.unite}</div></div>
            <div><div className="pn-label">Dispo net</div><div className="pn-mini-value">{fr(stock - (reserved[item] || 0))} {it.unite}</div></div>
            <div><div className="pn-label">Utilisé dans</div><div className="pn-mini-value">{usages.length} PF</div></div>
          </div>
        </div>

        <div className="pn-card pn-table-card">
          <div className="pn-table-head">
            <div className="pn-table-title">Cas d'emploi — {item} · {it.description}</div>
          </div>
          <div className="pn-table-wrap">
            <table className="pn-table">
              <thead>
                <tr>
                  <th>Produit fini</th>
                  <th>Description</th>
                  <th>Version</th>
                  <th className="num">Qté / PF</th>
                  <th className="num">Part du besoin</th>
                </tr>
              </thead>
              <tbody>
                {usages.map(({ n, quantite }) => {
                  const pct = Math.round((quantite / total) * 100);
                  return (
                    <tr key={n.ref_pf}>
                      <td className="pn-mono">
                        <button type="button" className="pn-link" onClick={() => openNomenclature(n.ref_pf)}>{n.ref_pf}</button>
                      </td>
                      <td>{descOf(n.ref_pf)}</td>
                      <td className="pn-muted">{n.version}</td>
                      <td className="num pn-mono">{fr(quantite)} {it.unite}</td>
                      <td>
                        <div className="pn-progress">
                          <div className="pn-progress-track"><div className="pn-progress-fill" style={{ width: `${pct}%` }} /></div>
                          <span className="pn-mono">{pct}%</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  /* ===================================================
     VUE 3 — PLANNING DE PRODUCTION (GANTT)
     =================================================== */
  const renderPlanning = () => {
    const debut = addDays(startOfWeek(today), -7 * SEMAINES_PASSEES);
    const nbJours = horizon * 7;
    const fin = addDays(debut, nbJours);
    const pos = (d) => Math.max(0, Math.min(100, (diffDays(d, debut) / nbJours) * 100));

    // Colonnes selon l'échelle
    const cols = [];
    if (echelle === 'day') {
      for (let i = 0; i < nbJours; i++) {
        const d = addDays(debut, i);
        const wd = (d.getDay() + 6) % 7;
        cols.push({
          key: i, label: pad(d.getDate()), sub: LETTRES_JOURS[wd],
          left: (i / nbJours) * 100, width: 100 / nbJours,
          cls: wd >= 5 ? 'pn-col-weekend' : diffDays(d, today) === 0 ? 'pn-col-today' : '',
        });
      }
    } else if (echelle === 'week') {
      for (let i = 0; i < horizon; i++) {
        const d = addDays(debut, i * 7);
        cols.push({
          key: i, label: `S${isoWeek(d)}`, sub: formatDate(d).slice(0, 5),
          left: (i / horizon) * 100, width: 100 / horizon, cls: '',
        });
      }
    } else {
      let d = debut;
      while (d < fin) {
        const next = new Date(d.getFullYear(), d.getMonth() + 1, 1);
        const b = next < fin ? next : fin;
        cols.push({
          key: toISO(d), label: MOIS[d.getMonth()], sub: String(d.getFullYear()),
          left: pos(d), width: pos(b) - pos(d), cls: '',
        });
        d = b;
      }
    }

    const visibles = plan.filter((p) => p.livraison >= debut && p.debutProd < fin);
    const minWidth = Math.max(1080, LARGEUR_LIBELLE + nbJours * PX_PAR_JOUR[echelle]);
    const todayLeft = pos(today);

    return (
      <>
        <div className="pn-card pn-table-card">
          <div className="pn-table-head">
            <div className="pn-gantt-controls">
              <div className="pn-table-title">Planning de production · {horizon} semaines</div>
              <div className="pn-seg" role="group" aria-label="Échelle du planning">
                {ECHELLES.map((e) => (
                  <button
                    key={e.key}
                    type="button"
                    aria-pressed={echelle === e.key}
                    className={`pn-seg-btn ${echelle === e.key ? 'active' : ''}`}
                    onClick={() => setEchelle(e.key)}
                  >
                    {e.label}
                  </button>
                ))}
              </div>
              <div className="pn-field-inline">
                <label className="pn-label" htmlFor="pn-horizon">Horizon</label>
                <select id="pn-horizon" className="pn-select pn-select-sm" value={horizon} onChange={(e) => setHorizon(parseInt(e.target.value, 10))}>
                  {HORIZONS.map((h) => <option key={h} value={h}>{h} semaines</option>)}
                </select>
              </div>
            </div>
            <div className="pn-legend">
              <span><i className="pn-lg pn-lg-appro" />Délai appro composants</span>
              <span><i className="pn-lg pn-lg-late" />Appro en retard</span>
              <span><i className="pn-lg pn-lg-prod" />Production</span>
              <span><i className="pn-lg pn-lg-diamond" />Livraison client</span>
              <span><i className="pn-lg pn-lg-today" />Aujourd'hui</span>
            </div>
          </div>

          <div className="pn-table-wrap">
            <div className="pn-gantt" style={{ minWidth: `${minWidth}px` }}>
              {/* Entête */}
              <div className="pn-gantt-row pn-gantt-header">
                <div className="pn-gantt-label pn-gantt-label-head">Commande · PF</div>
                <div className="pn-gantt-track pn-gantt-track-head">
                  {cols.map((c) => (
                    <div key={c.key} className={`pn-gantt-col pn-gantt-col-head ${c.cls}`} style={{ left: `${c.left}%`, width: `${c.width}%` }}>
                      <span className="pn-gantt-col-label">{c.label}</span>
                      <span className="pn-gantt-col-sub">{c.sub}</span>
                    </div>
                  ))}
                </div>
              </div>

              {visibles.length === 0 && (
                <div className="pn-empty">Aucun ordre de fabrication sur cet horizon. Allonge l'horizon pour voir les commandes suivantes.</div>
              )}

              {/* Lignes OF */}
              {visibles.map((p) => {
                const apL = pos(p.debutAppro);
                const prL = pos(p.debutProd);
                const dvL = pos(p.livraison);
                const selected = ofSel === p.c.commande;
                return (
                  <div key={p.c.commande} className={`pn-gantt-row ${selected ? 'pn-gantt-row-selected' : ''}`}>
                    <div className="pn-gantt-label">
                      <button
                        type="button"
                        className="pn-gantt-label-btn"
                        aria-pressed={selected}
                        title="Afficher la nomenclature de cet OF"
                        onClick={() => setOfSel(selected ? null : p.c.commande)}
                      >
                        <span className="pn-gantt-ref">{p.c.commande} · {p.c.client}</span>
                        <span className="pn-gantt-desc">
                          <span className="pn-gantt-pf">{p.c.ref_pf}</span> × {p.c.quantite} — {descOf(p.c.ref_pf)}
                        </span>
                      </button>
                    </div>
                    <div className="pn-gantt-track">
                      {cols.map((c) => (
                        <div key={c.key} className={`pn-gantt-col ${c.cls}`} style={{ left: `${c.left}%`, width: `${c.width}%` }} />
                      ))}
                      <div className="pn-gantt-today" style={{ left: `${todayLeft}%` }} />
                      {p.delai > 0 && (
                        <div
                          className={`pn-bar pn-bar-appro ${p.retard ? 'late' : ''}`}
                          style={{ left: `${apL}%`, width: `${prL - apL}%` }}
                          title={`Appro composants : ${formatDate(p.debutAppro)} → ${formatDate(p.debutProd)} (${p.delai} j)`}
                        >
                          Appro {p.delai} j
                        </div>
                      )}
                      <div
                        className="pn-bar pn-bar-prod"
                        style={{ left: `${prL}%`, width: `${dvL - prL}%` }}
                        title={`Production : ${formatDate(p.debutProd)} → ${formatDate(p.livraison)}`}
                      >
                        {p.b.temps_production} j
                      </div>
                      {p.livraison <= fin && (
                        <div className="pn-diamond" style={{ left: `${dvL}%` }} title={`Livraison ${formatDate(p.livraison)}`} />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* ---------- Nomenclature de l'OF sélectionné ---------- */}
        {(() => {
          const p = plan.find((x) => x.c.commande === ofSel);
          if (!p) {
            return (
              <div className="pn-card pn-empty pn-hint-card">
                Clique sur une commande dans le planning pour afficher la nomenclature du produit fini et la couverture de chaque composant.
              </div>
            );
          }
          return (
            <div className="pn-card pn-table-card pn-of-detail">
              <div className="pn-table-head">
                <div className="pn-table-title">
                  Nomenclature {p.c.ref_pf} — {descOf(p.c.ref_pf)} · {p.c.commande} ({p.c.client}) × {p.c.quantite}
                </div>
                <div className="pn-actions">
                  <button type="button" className="pn-btn" onClick={() => openNomenclature(p.c.ref_pf, p.c.date_livraison)}>Ouvrir la nomenclature</button>
                  <button type="button" className="pn-btn" onClick={() => setOfSel(null)}>Fermer</button>
                </div>
              </div>
              <div className="pn-table-wrap">
                <table className="pn-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Description</th>
                      <th className="num">Qté / PF</th>
                      <th className="num">Besoin OF</th>
                      <th className="num">Stock dispo pour l'OF</th>
                      <th className="num">Manquant</th>
                      <th className="num">Délai appro</th>
                      <th>Commander avant</th>
                      <th>Couverture</th>
                    </tr>
                  </thead>
                  <tbody>
                    {p.lignesDetail.map((l) => {
                      const it = itemsMap[l.item] || {};
                      const delai = Number(it.delai_appro) || 0;
                      const commanderAvant = addDays(p.debutProd, -delai);
                      const enRetard = !l.couvert && commanderAvant < today;
                      return (
                        <tr key={l.item}>
                          <td className="pn-mono">
                            <button type="button" className="pn-link" onClick={() => openCasEmploi(l.item)}>{l.item}</button>
                          </td>
                          <td>{it.description || '—'}</td>
                          <td className="num pn-mono">{fr(l.quantite)}</td>
                          <td className="num pn-mono"><strong>{fr(l.besoin)}</strong> {it.unite}</td>
                          <td className="num pn-mono">{fr(l.dispoAvant)}</td>
                          <td className="num pn-mono">{l.manque > 0 ? <span className="pn-badge pn-badge-warn">{fr(l.manque)}</span> : '—'}</td>
                          <td className="num pn-mono">{delai} j</td>
                          <td className="pn-mono">
                            {l.couvert ? '—' : enRetard
                              ? <span className="pn-badge pn-badge-warn">{formatDate(commanderAvant)} · retard</span>
                              : formatDate(commanderAvant)}
                          </td>
                          <td>
                            {l.couvert
                              ? <span className="pn-badge pn-badge-ok">Couvert par le stock</span>
                              : <span className="pn-badge pn-badge-info">À commander</span>}
                          </td>
                        </tr>
                      );
                    })}
                    <tr className="pn-row-prod">
                      <td className="pn-mono"><strong>PRODUCTION</strong></td>
                      <td>Production / assemblage du PF</td>
                      <td className="num pn-mono"><strong>{p.b.temps_production} j</strong></td>
                      <td className="num pn-muted">—</td>
                      <td className="num pn-muted">—</td>
                      <td className="num pn-muted">—</td>
                      <td className="num pn-muted">—</td>
                      <td className="pn-mono"><strong>Lancer le {formatDate(p.debutProd)}</strong></td>
                      <td className="pn-mono">Livraison {formatDate(p.livraison)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="pn-footnote">
                Stock dispo pour l'OF = stock restant après affectation aux commandes livrées avant celle-ci. Commander avant = début de production − délai appro du composant.
              </div>
            </div>
          );
        })()}

      </>
    );
  };

  /* ===================================================
     VUE — PLAN DE PRODUCTION (vue synthétique)
     =================================================== */
  const badgeStatut = (statut) =>
    statut === 'Retard appro' ? 'pn-badge-warn' : statut === 'Stock OK' ? 'pn-badge-ok' : 'pn-badge-info';

  const voirDansPlanning = (commande) => {
    setOfSel(commande);
    setOnglet('planning');
  };

  const renderPlan = () => {
    const composantsACommander = new Set();
    plan.forEach((p) => p.manquants.forEach((m) => composantsACommander.add(m)));

    const FILTRES = [
      { key: 'tous', label: 'Tous', test: () => true },
      { key: 'risque', label: 'À risque', test: (p) => p.statut === 'Retard appro' },
      { key: 'commander', label: 'À commander', test: (p) => p.delai > 0 },
      { key: 'ok', label: 'Stock OK', test: (p) => p.statut === 'Stock OK' },
    ];
    const filtre = FILTRES.find((f) => f.key === planFiltre) || FILTRES[0];
    const lignes = plan.filter(filtre.test);

    return (
      <>
        <div className="pn-kpis">
          <div className="pn-kpi">
            <div className="pn-kpi-label">Ordres de fabrication</div>
            <div className="pn-kpi-value">{plan.length}</div>
            <div className="pn-kpi-sub">issus des commandes clients</div>
          </div>
          <div className="pn-kpi">
            <div className="pn-kpi-label">Jours de production</div>
            <div className="pn-kpi-value">{plan.reduce((a, p) => a + Number(p.b.temps_production || 0), 0)} j</div>
            <div className="pn-kpi-sub">charge totale planifiée</div>
          </div>
          <div className="pn-kpi">
            <div className="pn-kpi-label">Composants à commander</div>
            <div className="pn-kpi-value">{composantsACommander.size}</div>
            <div className="pn-kpi-sub">en rupture sur les OF à venir</div>
          </div>
          <div className="pn-kpi pn-kpi-warn">
            <div className="pn-kpi-label">OF à risque</div>
            <div className="pn-kpi-value">{plan.filter((p) => p.retard).length}</div>
            <div className="pn-kpi-sub">date de commande déjà dépassée</div>
          </div>
        </div>

        <div className="pn-card pn-table-card">
          <div className="pn-table-head">
            <div className="pn-gantt-controls">
              <div className="pn-table-title">Plan de production · {lignes.length} OF</div>
              <div className="pn-seg" role="group" aria-label="Filtrer par statut">
                {FILTRES.map((f) => (
                  <button
                    key={f.key}
                    type="button"
                    aria-pressed={planFiltre === f.key}
                    className={`pn-seg-btn ${planFiltre === f.key ? 'active' : ''}`}
                    onClick={() => setPlanFiltre(f.key)}
                  >
                    {f.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="pn-table-hint">Clic sur une commande → détail dans le planning</div>
          </div>
          <div className="pn-table-wrap">
            <table className="pn-table">
              <thead>
                <tr>
                  <th>Commande</th>
                  <th>Client</th>
                  <th>PF</th>
                  <th className="num">Qté</th>
                  <th>Début prod.</th>
                  <th>Fin / livraison</th>
                  <th className="num">Durée</th>
                  <th>Composants manquants</th>
                  <th>Commander avant</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                {lignes.length === 0 && (
                  <tr><td colSpan={10} className="pn-muted">Aucun OF pour ce filtre.</td></tr>
                )}
                {lignes.map((p) => {
                  const manquants = p.lignesDetail.filter((l) => !l.couvert);
                  return (
                    <tr key={p.c.commande}>
                      <td className="pn-mono">
                        <button type="button" className="pn-link" onClick={() => voirDansPlanning(p.c.commande)}>{p.c.commande}</button>
                      </td>
                      <td>{p.c.client}</td>
                      <td className="pn-mono">
                        <button type="button" className="pn-link" onClick={() => openNomenclature(p.c.ref_pf, p.c.date_livraison)}>{p.c.ref_pf}</button>
                      </td>
                      <td className="num pn-mono">{fr(p.c.quantite)}</td>
                      <td className="pn-mono">{formatDate(p.debutProd)}</td>
                      <td className="pn-mono">{formatDate(p.livraison)}</td>
                      <td className="num pn-mono">{p.b.temps_production} j</td>
                      <td className="pn-mono pn-small">
                        {manquants.length
                          ? manquants.map((l) => (
                              <span key={l.item} className="pn-badge pn-badge-warn pn-badge-gap">
                                {l.item} · {fr(l.manque)} {itemsMap[l.item]?.unite || ''}
                              </span>
                            ))
                          : <span className="pn-muted">aucun</span>}
                      </td>
                      <td className="pn-mono">{p.delai > 0 ? formatDate(p.debutAppro) : '—'}</td>
                      <td>
                        <span className={`pn-badge ${badgeStatut(p.statut)}`}>{p.statut}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="pn-footnote">
            Le stock en main est affecté aux commandes par date de livraison. Manquant = quantité non couverte par le stock pour cet OF. Commander avant = début de production − délai appro le plus long.
          </div>
        </div>
      </>
    );
  };

  /* ===================================================
     VUE 4 — CRÉER / MODIFIER
     =================================================== */
  const renderCreer = () => (
    <>
      <div className="pn-card pn-filters pn-grid-4">
        <div className="pn-field">
          <label className="pn-label" htmlFor="pn-new-pf">Produit fini (référence client)</label>
          <select
            id="pn-new-pf"
            className="pn-select"
            value={draft.ref_pf}
            onChange={(e) => setDraft((d) => ({ ...d, ref_pf: e.target.value }))}
          >
            <option value="">— Choisir —</option>
            {data.items.map((i) => (
              <option key={i.item} value={i.item}>
                {i.item} — {i.description}{bomMap[i.item] ? ' (nomenclature existante)' : ''}
              </option>
            ))}
          </select>
        </div>
        <div className="pn-field">
          <label className="pn-label" htmlFor="pn-copy">Partir d'une nomenclature existante</label>
          <select id="pn-copy" className="pn-select" value="" onChange={(e) => copierDepuis(e.target.value)}>
            <option value="">— Nomenclature vierge —</option>
            {data.nomenclatures.map((n) => <option key={n.ref_pf} value={n.ref_pf}>Copier {n.ref_pf}</option>)}
          </select>
        </div>
        <div className="pn-field">
          <label className="pn-label pn-label-strong" htmlFor="pn-temps">Temps de production (jours)</label>
          <input
            id="pn-temps"
            type="number"
            min="0"
            className="pn-input pn-input-highlight pn-mono"
            value={draft.temps_production}
            onChange={(e) => setDraft((d) => ({ ...d, temps_production: e.target.value }))}
          />
        </div>
        <div className="pn-field">
          <label className="pn-label" htmlFor="pn-version">Version</label>
          <input
            id="pn-version"
            type="text"
            className="pn-input"
            value={draft.version}
            onChange={(e) => setDraft((d) => ({ ...d, version: e.target.value }))}
          />
        </div>
      </div>

      <div className="pn-card pn-table-card">
        <div className="pn-table-head">
          <div className="pn-table-title">Lignes de nomenclature</div>
        </div>
        <div className="pn-table-wrap">
          <table className="pn-table">
            <thead>
              <tr>
                <th style={{ width: '220px' }}>Item</th>
                <th>Description (auto)</th>
                <th style={{ width: '130px' }}>Quantité</th>
                <th style={{ width: '110px' }}>Délai appro</th>
                <th style={{ width: '60px' }} />
              </tr>
            </thead>
            <tbody>
              {draft.lignes.map((l, i) => (
                <tr key={i}>
                  <td>
                    <select
                      aria-label={`Item ligne ${i + 1}`}
                      className="pn-select pn-select-cell pn-mono"
                      value={l.item}
                      onChange={(e) => majLigne(i, 'item', e.target.value)}
                    >
                      <option value="">— Item —</option>
                      {data.items
                        .filter((it) => it.item !== draft.ref_pf)
                        .map((it) => <option key={it.item} value={it.item}>{it.item}</option>)}
                    </select>
                  </td>
                  <td>{l.item ? descOf(l.item) : '—'}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      aria-label={`Quantité ligne ${i + 1}`}
                      className="pn-input pn-input-cell pn-mono"
                      value={l.quantite}
                      onChange={(e) => majLigne(i, 'quantite', e.target.value)}
                    />
                  </td>
                  <td className="pn-mono">{l.item ? `${itemsMap[l.item]?.delai_appro ?? '—'} j` : '—'}</td>
                  <td className="num">
                    <button type="button" className="pn-icon-btn" aria-label={`Supprimer la ligne ${i + 1}`} onClick={() => supprimerLigne(i)}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                        <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
              <tr className="pn-row-prod">
                <td className="pn-mono"><strong>PRODUCTION</strong></td>
                <td>Production / assemblage du PF (ligne obligatoire)</td>
                <td className="pn-mono"><strong>{draft.temps_production || 0} j</strong></td>
                <td className="pn-muted">—</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pn-form-actions">
          <button type="button" className="pn-btn pn-btn-dashed" onClick={ajouterLigne}>+ Ajouter une ligne</button>
          <div className="pn-actions">
            <button type="button" className="pn-btn" onClick={() => setOnglet('nomenclature')}>Annuler</button>
            <button type="button" className="pn-btn pn-btn-primary" onClick={enregistrer} disabled={saving}>
              {saving ? 'Enregistrement…' : 'Enregistrer'}
            </button>
          </div>
        </div>
      </div>
    </>
  );

  /* ===================================================
     RENDU
     =================================================== */
  return (
    <div className="pn-page">
      <div className="pn-header">
        <div className="pn-header-left">
          <div className="pn-header-accent" />
          <h1 className="pn-header-title">Nomenclatures</h1>
          {USE_DEMO_DATA && <span className="pn-badge pn-badge-info">Données d'exemple</span>}
        </div>
        <div className="pn-actions">
          <button type="button" className="pn-btn" onClick={() => alert('Import CSV / Excel : à venir.')}>Importer CSV / Excel</button>
          <button type="button" className="pn-btn pn-btn-primary" onClick={nouvelleNomenclature}>+ Nouvelle nomenclature</button>
        </div>
      </div>

      <div className="pn-tabs" role="tablist">
        {SOUS_ONGLETS.map((o) => (
          <button
            key={o.key}
            type="button"
            role="tab"
            aria-selected={onglet === o.key}
            className={`pn-tab ${onglet === o.key ? 'active' : ''}`}
            onClick={() => setOnglet(o.key)}
          >
            {o.label}
          </button>
        ))}
      </div>

      {loading && <div className="pn-card pn-empty">Chargement…</div>}
      {error && <div className="pn-card pn-empty pn-error">{error}</div>}

      {!loading && !error && (
        <div className="pn-content">
          {onglet === 'nomenclature' && renderNomenclature()}
          {onglet === 'casemploi' && renderCasEmploi()}
          {onglet === 'plan' && renderPlan()}
          {onglet === 'planning' && renderPlanning()}
          {onglet === 'creer' && renderCreer()}
        </div>
      )}
    </div>
  );
};

export default Productionnomenclature;